<template>
  <DxPopup
    :wrapperAttr="{ class: 'css-v2 generate-so-popup' }"
    :visible="showModal"
    :drag-enabled="false"
    :hide-on-outside-click="false"
    :show-title="true"
    :height="612"
    :title="'Generate Order for Contract #' + parentModel.Code"
    :showCloseButton="false"
    @shown="initialize"
  >
    <template #content>
      <div class="css-v2 transaction-screen">
        <div id="popup-wrapper">
          <DxScrollView id="generate-so-scrollview" ref="scrollViewWidget">
            <div class="view-card responsive-paddings">
              <form>
                <DxForm
                  :form-data="salesOrderHeader"
                  :read-only="false"
                  :show-colon-after-label="false"
                  :show-validation-summary="false"
                  :validation-group="'headerForm'"
                  :label-location="formsConfig.labelPosition"
                  :items="headerFormItems"
                  :show-required-mark="false"
                  ref="generate-so-header-form"
                  @content-ready="onFormContentReady"
                >
                  <!-- SelectBox Template  -->
                  <template #deliveryAddressTemplate="{ data }">
                    <div class="custom-auto-complete data-grid">
                      <span class="auto-complete-primary">{{
                        data.CompanyName
                      }}</span>
                      <div class="auto-complete-secondary no-padding">
                        <span v-if="data.PhysicalAddressStreetLine1 != ''">{{
                          data.PhysicalAddressStreetLine1
                        }}</span>
                        <span v-if="data.PhysicalAddressStreetLine2 != ''">
                          {{ data.PhysicalAddressStreetLine2 }}
                        </span>
                        <span v-if="data.PhysicalAddressSuburb != ''">
                          {{ data.PhysicalAddressSuburb }}
                        </span>
                        <span v-if="data.PhysicalAddressState != ''">
                          {{ data.PhysicalAddressState }}
                        </span>
                        <span v-if="data.PhysicalAddressPostcode != ''">
                          {{ data.PhysicalAddressPostcode }}
                        </span>
                      </div>
                    </div>
                  </template>
                  <template #agentTemplate="{ data }">
                    <div class="toolbar-auto-complete">
                      <span class="title">{{ data.Name }}</span>
                      <span class="sub-title" style="color: grey">{{
                        data.Code
                      }}</span>
                    </div>
                  </template>
                </DxForm>
              </form>
            </div>
            <div class="generate-so-details">
              <!--details grid -->
              <dx-data-grid
                v-if="loadingCompleted"
                class="dx-card wide-card stock-transfer-grid"
                :data-source="salesOrderDetailLines"
                :show-borders="false"
                :ref="'generate-so-grid'"
                :focused-row-enabled="false"
                :column-auto-width="true"
                :column-hiding-enabled="false"
                :hover-state-enabled="true"
                :column-min-width="100"
                :reshape-on-push="true"
                :height="320"
                @initialized="generateSoInitialized"
                :column-fixing-enabled="true"
                :columns="generateSoDetailsColumns"
                validation-group="formsData"
                @content-ready="addGridNoResults($event)"
                :allow-column-reordering="false"
                :column-chooser="{ enabled: false }"
              >
                <!-- key-expr="Key" -->
                <dx-paging :page-size="50" />
                <dx-pager :show-page-size-selector="true" :show-info="true" />

                <DxSearchPanel
                  :visible="true"
                  :highlight-case-sensitive="true"
                />
                <DxEditing :allow-updating="true" mode="cell" />
                <template #ProductTemplate="{ data }">
                  <div class="custom-auto-complete data-grid">
                    <span class="gc-grid-description">
                      {{ data.data.ProductDescription }}
                    </span>
                    <span class="gc-grid-code">{{
                      data.data.ProductCode
                    }}</span>
                  </div>
                </template>
                <template #qtyEditTemplate="{ data }">
                  <div>
                    <div>
                      <DxNumberBox
                        :value="data.value"
                        @value-changed="salesUMQtyChanged($event, data)"
                        :format="data.column.format"
                        class="gc-grid-number-box-editor"
                        :min="0"
                        :max="999999999.99"
                        @key-down="onKeyDown"
                        :step="0"
                      />
                    </div>
                  </div>
                </template>
                <template #priceEditTemplate="{ data }">
                  <div>
                    <div>
                      <DxNumberBox
                        :value="data.value"
                        @value-changed="salesUMFxPriceChanged($event, data)"
                        :format="data.column.format"
                        class="gc-grid-number-box-editor"
                        :min="0"
                        :max="999999999.99"
                      />
                    </div>
                  </div>
                </template>
                <template #lineTotalTemplate="{ data }">
                  <div class="gc-auto-cmp-nounderline">
                    <DxNumberBox
                      :read-only="true"
                      :value="data.data.DiscFXLineTotal + data.data.FXLineTotal"
                      @value-changed="salesUMFxPriceChanged($event, data)"
                      :format="data.column.format"
                      class="gc-grid-number-box-editor"
                      :min="0"
                      :max="999999999.99"
                    />
                  </div>
                </template>
                <template #sales-um-template="{ data }">
                  <div class="gc-auto-cmp-nounderline">
                    {{ data.data.SalesUM }}
                  </div>
                </template>

                <template #inc-checkbox-template="{ data }">
                  <div>
                    <DxCheckBox
                      :value="data.data.Include === true"
                      @value-changed="includeValueChanged($event, data)"
                      :ref="'cb-' + ''"
                    />
                  </div>
                </template>
              </dx-data-grid>
            </div>
          </DxScrollView>
          <div class="footer-actions">
            <DxButton
              class="action-button"
              text="Generate Orders"
              type="default"
              styling-mode="contained"
              :disabled="getEnableSave"
              @click="generateOrders"
            />
            <DxButton
              class="action-button"
              text="Back"
              type="normal"
              styling-mode="contained"
              @click="hideModal"
            />
          </div>
        </div>
      </div>
    </template>
  </DxPopup>
</template>
<script>
import BaseViewMixin from "../v1/_mixins/base.view";
import validationEngine from "devextreme/ui/validation_engine";
import ColumnWidth from "../_helpers/data-grid/ColumnWidth";
import { DxScrollView } from "devextreme-vue/scroll-view";
import { CustomerSalesContractService } from "../_services/api/accounts/customer-sales-contract.service";
import { CustomerFreightChargeService } from "../_services/api/accounts/customer-freight-charge.service";
import { ForeignCurrencyService } from "../_services/api/settings/accounting/foreign-currency.service";
import { CustomerDeliveryAddressService } from "../_services/api/customers/customer-delivery-address.service";
import { SalesOrderService } from "../_services/api/sales/sales-order.service";

import { SalesOrderHeader, SalesOrderDetail } from "../_models/sales-order";
import SalesFormulas from "../_helpers/formulas/sales-formulas";
import { CustomerService } from "../_services/api/customers/customer.service";

var customerDataSource = CustomerService.dataSourceConfig("api/Customer", {
  select: ["Code", "Name", "SalesRepresentativeCode", "CurrencyCode"],
  sort: [{ selector: "Name", asc: true }],
  top: 5,
  filter: ["Inactive", "=", "N"],
  count: true,
});

const {
  calculateDiscLineTotal,
  calculateNetLineTotal,
  calculateWetLineTotal,
  calculateTaxableLineTotal,
  calculateTaxLineTotal,
  calculateLineTotal,
  calculateDiscFXLineTotal,
  calculateNetFXLineTotal,
  calculateWetFXLineTotal,
  calculateTaxableFXLineTotal,
  calculateTaxFXLineTotal,
  calculateFXLineTotal,
  calculateCalculatedDiscPcnt,
  calculateSalesUMPriceFromSalesUMFXPrice,
  calculateSalesUMNetPriceFromSalesUMNetFXPrice,
  calculateStockUMNetFXPrice,
  calculateStockUMNetPrice,
  calculateStockUMFXPrice,
  calculateStockUMPrice,
  calculateSalesUMNetFXPriceFromSalesUMFXPrice,
} = SalesFormulas;

var deliveryAddressDataSource = CustomerDeliveryAddressService.dataSourceConfig(
  "api/CustomerDeliveryAddress",
  {
    select: [
      "CompanyName",
      "LineNo",
      "PhysicalAddressStreetLine1",
      "PhysicalAddressStreetLine2",
      "PhysicalAddressSuburb",
      "PhysicalAddressState",
      "PhysicalAddressPostcode",
      "PhysicalAddressCountry",
      "RecordId",
      "Inactive",
    ],
    key: "RecordId",
  },
);

// eslint-disable-next-line no-unused-vars
let generateSoGridInstance = null;
export default {
  mixins: [BaseViewMixin],
  components: {
    DxScrollView,
  },
  props: {
    showModal: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    parentModel: {
      type: Object,
      default: () => {},
    },
    parentContractLines: {
      type: Array,
    },
  },
  watch: {
    showModal: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      handler: function (newVal, oldVal) {
        if (newVal) {
          this.$logger.trackEventOpenPopup("Generate Sales Order");
        }
      },
    },
  },
  mounted() {
    // eslint-disable-next-line no-console
    this.$logger.debug("parentContractLines", this.parentContractLines);
  },
  data() {
    return {
      isSaving: false,
      salesOrderHeader: new SalesOrderHeader(),
      salesOrderDetailLines: [],
      generateSoDataSourceConfig: [],
      NextConfirmationNo: 1,
      customerName: "",
      freightCharges: [],
      enableSave: true,
    };
  },
  computed: {
    getEnableSave() {
      return this.enableSave;
    },
    headerFormItems() {
      let items = [
        {
          itemType: "group",
          caption: "",
          colCount: 3,
          items: [
            {
              itemType: "group",
              caption: "",
              items: this.parseFormColumns([
                {
                  dataField: "CustomerCode",
                  gcLabel: "Customer",
                  gcType: "String",
                  ref: "customerCode",
                  cssClass: "toolbar-customer-label",
                  editorType: this.isTablet ? "dxTextBox" : "dxSelectBox",
                  readOnly: this.parentModel.Type != "Allocation",
                  required: true,
                  editorOptions: {
                    dataSource: customerDataSource,
                    valueExpr: "Code",
                    displayExpr: "Name",
                    searchExpr: ["Code", "Name"],
                    searchMode: "contains",
                    showClearButton: true,
                    itemTemplate: "agentTemplate",
                    searchEnabled: true,
                    onValueChanged: this.onCustomerCodeValueChanged.bind(this),
                    // key: "RecordId",
                    placeholder: "Customer Name",
                  },
                },
                {
                  dataField: "OrderNo",
                  gcType: "String",
                  editorType: "dxTextBox",
                  gcLabel: "Cust PO",
                  required: true,
                  editorOptions: {
                    readOnly: false,
                    maxLength: 200,
                    onValueChanged: this.onOrderNoChanged.bind(this),
                  },
                  validationRules: [
                    {
                      type: "required",
                      message: "Cust PO is required",
                    },
                  ],
                },
                {
                  dataField: "AgentRef",
                  gcType: "String",
                  editorType: "dxTextBox",
                  gcLabel: "Agent Ref",
                },
              ]),
            },

            {
              itemType: "group",
              caption: "",
              items: this.parseFormColumns([
                {
                  dataField: "Confirmation",
                  gcLabel: "Confirmation",
                  gcType: "String",
                  editorType: "dxTextBox",
                  required: true,
                },
                {
                  gcLabel: "Deliver To",
                  gcType: "String",
                  dataField: "CustomerDeliveryAddressLineNo",
                  validationRules: [
                    {
                      type: "required",
                      message: "Delivery address is required",
                    },
                  ],
                  editorType: this.isTablet ? "dxTextBox" : "dxSelectBox",
                  editorOptions: {
                    dataSource: deliveryAddressDataSource,
                    valueExpr: "LineNo",
                    displayExpr: "CompanyName",
                    searchExpr: ["CustomerCode", "CompanyName"],
                    searchMode: "contains",
                    showClearButton: false,
                    itemTemplate: "deliveryAddressTemplate",
                    // onCustomItemCreating: this.customItemCreating,
                    searchEnabled: true,
                    openOnFieldClick: true,
                    onValueChanged: this.onDeliveryAddressChanged.bind(this),
                  },
                  required: true,
                },
              ]),
            },

            {
              itemType: "group",
              caption: "",
              items: this.parseFormColumns([
                {
                  dataField: "ShipDate",
                  gcType: "Date",
                  gcLabel: "Ship Date",
                  required: true,
                },
                {
                  dataField: "RequiredByDate",
                  gcType: "Date",
                  gcLabel: "Reqd By",
                  required: true,
                  editorOptions: {
                    onValueChanged: this.validateRequiredByDate.bind(this),
                    min: this.parentModel.StartDate
                      ? this.parentModel.StartDate
                      : undefined,
                    max: this.parentModel.EndDate
                      ? this.parentModel.EndDate
                      : undefined,
                    dateOutOfRangeMessage:
                      this.parentModel.StartDate && this.parentModel.EndDate
                        ? `Required by Date must be between Contract Start Date (${new Date(
                            this.parentModel.StartDate.replace("Z", ""),
                          ).toShortDateString()}) and End Date (${new Date(
                            this.parentModel.EndDate.replace("Z", ""),
                          ).toShortDateString()}).`
                        : `Required by Date must be between Contract Start Date and End Date.`,
                  },
                },
                {
                  dataField: "FXTotal",
                  gcType: "Decimal-4-2C",
                  gcDynamicLabel: this.headerFormFxTotalLabel,
                  readOnly: true,
                },
              ]),
            },
          ],
        },
      ];

      return items;
    },
    generateSoDetailsColumns() {
      return [
        {
          caption: "Inc",
          dataField: "Include",
          type: "String",
          width: 50,
          minWidth: 50,
          showEditorAlways: true,
          editCellTemplate: "inc-checkbox-template",
          fixed: true,
          fixedPosition: "left",
          alignment: "center",
        },
        {
          caption: "Product",
          dataField: "ProductDescription",
          type: "String",
          minWidth: 200,
          cellTemplate: "ProductTemplate",
          sortOrder: "asc",
        },
        {
          caption: "Line",
          dataField: "CustomerSalesContractLineNo",
          width: 70,
          minWidth: 70,
          alignment: "center",
        },
        {
          caption: "UM",
          dataField: "SalesUM",
          type: "String",
          minWidth: ColumnWidth.UnitOfMeasure.minWidth,
          width: ColumnWidth.UnitOfMeasure.width,
          alignment: "center",
        },
        {
          caption: "Available",
          dataField: "AvailableQuantity",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          format: this.getDecimalFormatByCode(3).Format,
          alignment: "right",
          cssClass: this.cellEditorClass,
        },
        {
          caption: "Quantity",
          dataField: "SalesUMQty",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          format: this.getDecimalFormatByCode(3).Format,
          alignment: "right",
          cssClass: this.cellEditorClass,
          editCellTemplate: "qtyEditTemplate",
          showEditorAlways: true,
          allowEditing: true,
        },
        {
          caption: this.salesContractColumnDefaultPriceLabel,
          dataField: "SalesUMFXPrice",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          format: this.getDecimalFormatByCode(3).Format,
          alignment: "right",
          cssClass: this.cellEditorClass,
          editCellTemplate: "priceEditTemplate",
          showEditorAlways: true,
          allowEditing: true,
        },
        {
          caption: this.soDetailsColumnTotalLabel,
          dataField: "FXLineTotal",
          minWidth: ColumnWidth.Quantity2DecimalPoints.minWidth,
          width: ColumnWidth.Quantity2DecimalPoints.width,
          format: this.getDecimalFormatByCode(2).Format,
          alignment: "right",
          cssClass: this.cellEditorClass,
          cellTemplate: "lineTotalTemplate",
          allowEditing: false,
        },
      ];
    },
    salesContractColumnDefaultPriceLabel() {
      return `Price (${this.parentModel.CurrencyCode})`;
    },
    soDetailsColumnTotalLabel() {
      return `Total (${this.parentModel.CurrencyCode})`;
    },
    headerFormFxTotalLabel() {
      return `Total (${this.parentModel.CurrencyCode})`;
    },
  },
  methods: {
    onKeyDown() {
      this.enableSave = true;
    },
    async onCustomerCodeValueChanged() {
      if (this.salesOrderHeader.CustomerCode !== null) {
        let { data } = await CustomerService.getByCode(
          this.salesOrderHeader.CustomerCode,
        );

        let customer = data.value[0];

        this.customerName = customer.Name;
        this.salesOrderHeader.CurrencyCode = customer.CurrencyCode;
        this.salesOrderHeader.SalesRepresentativeCode =
          customer.SalesRepresentativeCode
            ? customer.SalesRepresentativeCode
            : this.getFactorByCode(95).Factorc;

        let currency = await ForeignCurrencyService.getByCode(
          customer.CurrencyCode,
        );

        this.ExchangeRate = currency.data.value[0].BuyRate;

        this.salesOrderHeader.ExchangeRate = this.ExchangeRate;
        this.salesOrderHeader.CustomerDeliveryAddressLineNo = undefined;

        await this.setNextConfirmationNo();

        this.salesOrderHeader.Confirmation =
          this.parentModel.Code + "-" + this.NextConfirmationNo;
      }

      deliveryAddressDataSource.filter([
        ["CustomerCode", "=", this.salesOrderHeader.CustomerCode],
        "and",
        ["Inactive", "=", "N"],
      ]);
      deliveryAddressDataSource.load();
    },
    async onOrderNoChanged(e) {
      if (this.getFactorByCode(578).Factorc !== "Y" || e.value == "") return;
      let orderNo = e.value;

      let result = await SalesOrderService.findOrderNoUsageForSalesOrder(
        orderNo,
        "",
        this.parentModel.CustomerCode,
      );

      let orderNoUsedPreviously = result.data.value.length > 0;
      if (!orderNoUsedPreviously) {
        result = await SalesOrderService.findOrderNoUsageForInvoice(
          orderNo,
          "",
          this.parentModel.CustomerCode,
        );
        orderNoUsedPreviously = result.data.value.length > 0;
      }

      if (orderNoUsedPreviously) {
        // Show prompt
        let confirmOrderNoReuse = await this.$confirm(
          `Customer ${this.customerName} has used Customer PO ${orderNo} previously. Will you use Customer PO ${orderNo} again?`,
          "Customer PO Used Previously",
        );

        if (!confirmOrderNoReuse) {
          e.component.focus();
          e.element.querySelector("input").select();
        }
      }
    },
    async setNextConfirmationNo() {
      let { data } = await CustomerSalesContractService.getLatestConfirmationNo(
        this.salesOrderHeader.CustomerCode,
        this.parentModel.Code,
        this.getFactorByCode(650).FactorInt,
      );

      if (data.value.length > 0) {
        var no =
          data.value[0][
            "UserComment" + this.getFactorByCode(650).FactorInt
          ].split("-");
        this.NextConfirmationNo = Number(no[1]) + 1;
      }
    },
    calculateTotals() {
      // record is a detail record
      let self = this;

      var includedLines = this.salesOrderDetailLines.filter(
        (item) => item.Include === true,
      );

      if (includedLines.length == 0) {
        self.salesOrderHeader.ItemCount = 0;
        self.salesOrderHeader.ExTaxTotal = 0;
        self.salesOrderHeader.TaxTotal = 0;
        self.salesOrderHeader.Total = 0;
        self.salesOrderHeader.FXTotal = 0;
      } else {
        self.salesOrderHeader.ItemCount = includedLines.reduce(function (
          prev,
          cur,
        ) {
          return prev + Math.floor(cur.StockUMQty);
        },
        0);

        self.salesOrderHeader.ExTaxTotal = includedLines
          .reduce(function (prev, cur) {
            return prev + cur.TaxableLineTotal;
          }, 0)
          .roundNumber(2);
        self.salesOrderHeader.TaxTotal = includedLines
          .reduce(function (prev, cur) {
            return prev + cur.TaxLineTotal;
          }, 0)
          .roundNumber(2);
        self.salesOrderHeader.Total = includedLines
          .reduce(function (prev, cur) {
            return prev + cur.LineTotal;
          }, 0)
          .roundNumber(2);
        self.salesOrderHeader.FXTotal = includedLines
          .reduce(function (prev, cur) {
            return prev + cur.FXLineTotal + cur.DiscFXLineTotal;
          }, 0)
          .roundNumber(2);
      }

      this.enableSave = false;
      this.showLoading(false);
      // this.$store.dispatch("ui/setEnableGenerate", false);
    },

    onFormContentReady() {
      validationEngine.validateGroup("headerForm");
    },
    generateSoInitialized(e) {
      generateSoGridInstance = e.component;
    },
    async hideModal() {
      let confirmLeaving = await this.$confirm(
        "You have unsaved changes. Are you sure you want to leave?",
        "Unsaved changes",
      );

      if (confirmLeaving) {
        this.reset();
        this.$emit("close-form");
      }
    },

    getValidationResult(messages) {
      let validationResult = { brokenRules: [] };
      messages.forEach((m) => {
        validationResult.brokenRules.push({ message: m });
      });

      return validationResult;
    },

    includeValueChanged(e, cellInfo) {
      let self = this;
      let record = cellInfo.data;
      record.Include = e.value;

      if (e.value) {
        // var balance = 0;

        // var thisContractLines = this.salesOrderDetailLines.filter(
        //   (item) =>
        //     item.Include === true &&
        //     item.CustomerSalesContractCode ===
        //       record.CustomerSalesContractCode &&
        //     item.CustomerSalesContractLineNo ===
        //       record.CustomerSalesContractLineNo &&
        //     item.ItemCode !== record.ItemCode
        // );

        // if (thisContractLines.length > 0) {
        //   balance = thisContractLines.reduce(function (prev, cur) {
        //     return prev + cur.SalesUMQty;
        //   }, 0);
        // }

        var totalQty = record.SalesUMQty; // + balance;

        if (totalQty > record.AvailableQuantity) {
          let validationResult = this.getValidationResult([
            `${this.parentModel.Name}, Line ${
              record.CustomerSalesContractLineNo
            } has a remaining contract quantity of ${this.formatNumber(
              record.AvailableQuantity,
            )}. The quantity for product ${
              record.ProductDescription
            } takes the drawn quantity to ${this.formatNumber(
              totalQty,
            )} which exceeds the remaining contract quantity.`,
          ]);
          this.$emit("show-validation-errors", validationResult);

          setTimeout(function () {
            record.SalesUMQty = 0;
            self.recalculateRecordData(record);
          }, 0);
          return;
        }
      }

      this.calculateTotals();
    },
    salesUMFxPriceChanged(e, cellInfo) {
      let record = cellInfo.data;
      record.SalesUMFXPrice = e.value;

      this.recalculateRecordData(record);
    },
    salesUMQtyChanged(e, cellInfo) {
      this.showLoading(true);
      let self = this;
      let record = cellInfo.data;

      record.SalesUMQty = e.value;

      if (record.Include) {
        // var balance = 0;

        // var thisContractLines = this.salesOrderDetailLines.filter(
        //   (item) =>
        //     item.Include === true &&
        //     item.CustomerSalesContractCode ===
        //       record.CustomerSalesContractCode &&
        //     item.CustomerSalesContractLineNo ===
        //       record.CustomerSalesContractLineNo &&
        //     item.ItemCode !== record.ItemCode
        // );

        // if (thisContractLines.length > 0) {
        //   balance = thisContractLines.reduce(function (prev, cur) {
        //     return prev + cur.SalesUMQty;
        //   }, 0);
        // }

        var totalQty = e.value; // + balance;

        if (totalQty > record.AvailableQuantity) {
          let validationResult = this.getValidationResult([
            `${this.parentModel.Name}, Line ${
              record.CustomerSalesContractLineNo
            } has a remaining contract quantity of ${this.formatNumber(
              record.AvailableQuantity,
            )}. The quantity for product ${
              record.ProductDescription
            } takes the drawn quantity to ${this.formatNumber(
              totalQty,
            )} which exceeds the remaining contract quantity.`,
          ]);
          this.$emit("show-validation-errors", validationResult);

          setTimeout(function () {
            record.SalesUMQty = 0;
            self.recalculateRecordData(record);
          }, 0);
          return;
        }
      }
      this.setSaleItemPrice(record);
    },
    async setSaleItemPrice(record) {
      let self = this;
      await SalesOrderService.setSaleItemPrice(
        record,
        this.salesOrderHeader.SalesOrderTypeCode,
        this.salesOrderHeader.BranchCode,
        this.salesOrderHeader.CustomerCode,
        this.salesOrderHeader.ExchangeRate,
        this.salesOrderHeader.DateIn,
        this.salesOrderHeader.RequiredByDate,
        true,
      ).then(function () {
        record.RequiredByDate = self.salesOrderHeader.RequiredByDate;

        record.ShipDate = self.salesOrderHeader.ShipDate;

        if (self.getFactorByCode(505) !== null) {
          record.IsCommentVisible =
            self.getFactorByCode(505).Factorc.toUpperCase() === "Y";
        }

        if (record.UseMarket.toUpperCase() === "N") {
          record.SalesUMFXPrice = record.DefaultPrice;
        }

        if (record.ApplyFreight == "Y") {
          record.SalesUMFXPrice += self.getFreightCharge(record.SalesUM);
        }
        self.recalculateRecordData(record);
      });
    },
    validateRequiredByDate(e) {
      if (!e || !e.event) return true; // if e is null or undefined, or if e.event is not present, skip validation

      let contractStartDate = this.parentModel.StartDate.toSaveDateObject();

      let contractEndDate = this.parentModel.EndDate
        ? this.parentModel.EndDate.toSaveDateObject()
        : null;
      let requiredByDate =
        this.salesOrderHeader.RequiredByDate.toSaveDateObject();

      if (contractEndDate) {
        if (
          requiredByDate >= contractStartDate &&
          requiredByDate <= contractEndDate
        ) {
          return true;
        }
      } else {
        if (requiredByDate >= contractStartDate) return true;
      }

      var brokenRules = [
        {
          message: `Required by Date is outside Contract Start and End Date range.`,
        },
      ];

      this.$emit("show-validation-errors", { brokenRules: brokenRules });
      return true;
    },
    async generateOrders() {
      let self = this;
      let validationResult = await validationEngine.validateGroup("headerForm");

      if (!validationResult.isValid) {
        this.$emit("show-validation-errors", validationResult);
        return;
      }

      // if (this.validateRequiredByDate() == false) return;

      if (this.getFactorByCode(649).FactorInt !== 0) {
        this.salesOrderHeader[
          "UserComment" + this.getFactorByCode(649).FactorInt
        ] = this.salesOrderHeader.AgentRef;
      }

      if (this.getFactorByCode(650).FactorInt !== 0) {
        this.salesOrderHeader[
          "UserComment" + this.getFactorByCode(650).FactorInt
        ] = this.salesOrderHeader.Confirmation;
      }

      this.salesOrderHeader.SalesOrderDetails =
        this.salesOrderDetailLines.filter(
          (item) => item.Include === true && item.SalesUMQty !== 0,
        );

      this.$logger.trackEventButtonClick(
        `Contract Generate Order From Contract`,
      );

      let copyOfSalesOrderHeader = JSON.parse(
        JSON.stringify(this.salesOrderHeader),
      );

      copyOfSalesOrderHeader.RequiredByDate = new Date(
        copyOfSalesOrderHeader.RequiredByDate,
      ).toSaveDate();
      copyOfSalesOrderHeader.ShipDate = new Date(
        copyOfSalesOrderHeader.ShipDate,
      ).toSaveDate();
      copyOfSalesOrderHeader.DateIn = new Date(
        copyOfSalesOrderHeader.DateIn,
      ).toSaveDate();

      copyOfSalesOrderHeader.SalesOrderDetails.forEach((record) => {
        record.RequiredByDate = copyOfSalesOrderHeader.RequiredByDate;
        record.ShipDate = copyOfSalesOrderHeader.ShipDate;
      });

      let payload = JSON.stringify(copyOfSalesOrderHeader);

      this.showLoading(true);
      await SalesOrderService.saveSalesOrder(JSON.parse(payload), 0)
        .then((res) => {
          self.showLoading(false);

          self.$notify(
            `Sales Order ${res.data.Code} Successfully Saved`,
            "success",
          );
          this.reset();
          this.$emit("close-form", true);
        })
        .catch((error) => {
          self.showLoading(false);
          // self.displayServerError(error, "Save sales order Failed");
          self.$emit("show-server-errors", error, "Save sales order Failed");
          self.refreshAvailableQty();
        });
    },
    async initialize() {
      this.showLoading(true);
      this.loadingCompleted = false;
      this.reset();
      await this.$store.dispatch(
        "screenFactors/getFactors",
        [505, 87, 95, 649, 650, 578],
      );

      this.salesOrderHeader.CustomerCode = this.parentModel.CustomerCode;

      this.salesOrderHeader.SalesRepresentativeCode =
        this.getFactorByCode(95).Factorc;

      if (this.salesOrderHeader.CustomerCode !== null) {
        let { data } = await CustomerService.getByCode(
          this.salesOrderHeader.CustomerCode,
        );

        let customer = data.value[0];

        this.customerName = customer.Name;
        this.salesOrderHeader.CurrencyCode = customer.CurrencyCode;
        this.salesOrderHeader.SalesRepresentativeCode =
          customer.SalesRepresentativeCode
            ? customer.SalesRepresentativeCode
            : this.getFactorByCode(95).Factorc;

        let currency = await ForeignCurrencyService.getByCode(
          customer.CurrencyCode,
        );

        this.ExchangeRate = currency.data.value[0].BuyRate;

        this.salesOrderHeader.ExchangeRate = this.ExchangeRate;

        await this.setNextConfirmationNo();

        this.salesOrderHeader.Confirmation =
          this.parentModel.Code + "-" + this.NextConfirmationNo;
      }

      this.salesOrderHeader.CompanyCode = this.parentModel.CompanyCode;
      this.salesOrderHeader.BranchCode = this.parentModel.BranchCode;
      this.salesOrderHeader.DivisionCode = this.parentModel.DivisionCode;

      this.salesOrderHeader.SalesOrderTypeCode =
        this.getFactorByCode(87).Factorc;

      let { data: consumptionData } =
        await CustomerSalesContractService.getCustomerSalesContractItemConsumption(
          this.parentModel.Code,
        );

      consumptionData.value.forEach((c) => {
        let salesOrderDetail = new SalesOrderDetail();

        salesOrderDetail.Include = false;

        salesOrderDetail.SalesUMQty = 0;
        salesOrderDetail.UseMarket = c.UseMarket;
        salesOrderDetail.ApplyFreight = c.ApplyFreight;
        salesOrderDetail.DefaultPrice = c.DefaultPrice;
        salesOrderDetail.CustomerSalesContractCode =
          c.CustomerSalesContractCode;
        salesOrderDetail.CustomerSalesContractLineNo =
          c.CustomerSalesContractLineNo;
        salesOrderDetail.ProductDescription = c.ProductDescription;
        salesOrderDetail.ProductCode = c.ProductCode;
        salesOrderDetail.AvailableQuantity = c.AvailableQuantity;
        salesOrderDetail.ItemCode = c.ProductCode;
        salesOrderDetail.SalesUM = c.SalesUM;
        salesOrderDetail.IsCommentVisible =
          this.getFactorByCode(505).Factorc.toUpperCase();

        this.salesOrderDetailLines.push(salesOrderDetail);
      });

      deliveryAddressDataSource.filter([
        ["CustomerCode", "=", this.salesOrderHeader.CustomerCode],
        "and",
        ["Inactive", "=", "N"],
      ]);
      deliveryAddressDataSource.load();

      this.setInitialPrices();
      this.showLoading(false);
      this.loadingCompleted = true;
    },
    setInitialPrices() {
      this.salesOrderDetailLines.forEach((record) => {
        this.setSaleItemPrice(record);
      });
    },
    async refreshAvailableQty() {
      let { data } =
        await CustomerSalesContractService.getCustomerSalesContractLineConsumption(
          this.parentModel.Code,
        );

      data.value.forEach((c) => {
        // look for this
        this.salesOrderDetailLines
          .filter(
            (item) =>
              item.CustomerSalesContractCode === c.CustomerSalesContractCode &&
              item.CustomerSalesContractLineNo === c.LineNo,
          )
          .forEach(function (item) {
            item.AvailableQuantity = c.AvailableQuantity;
          });
      });
    },
    async onDeliveryAddressChanged(e) {
      let address = e.component
        .option("items")
        .find((x) => x.LineNo == e.value);

      // eslint-disable-next-line no-console
      this.$logger.debug("onDeliveryAddressChanged", e);

      // let { data } = await CustomerDeliveryAddressService.getByName(e.value);
      // let address = data.value[0];
      if (address) {
        this.salesOrderHeader.DeliveryAddressCompanyName = address.CompanyName;

        this.salesOrderHeader.DeliveryAddressStreetLine1 =
          address.PhysicalAddressStreetLine1;
        this.salesOrderHeader.DeliveryAddressStreetLine2 =
          address.PhysicalAddressStreetLine2;
        this.salesOrderHeader.DeliveryAddressSuburb =
          address.PhysicalAddressSuburb;
        this.salesOrderHeader.DeliveryAddressState =
          address.PhysicalAddressState;
        this.salesOrderHeader.DeliveryAddressPostcode =
          address.PhysicalAddressPostcode;
        this.salesOrderHeader.DeliveryAddressCountry =
          address.PhysicalAddressCountry;
        // this.salesOrderHeader.CustomerDeliveryAddressLineNo = address.LineNo.toString();

        let ds = CustomerFreightChargeService.dataSourceConfig(
          "api/CustomerSalesContractFreightCharge",
          {
            filter: [
              ["CustomerCode", "=", this.salesOrderHeader.CustomerCode],
              "and",
              ["DeliveryCode", "=", address.LineNo],
            ],
          },
        );
        this.freightCharges = await ds.load();
        // eslint-disable-next-line no-console
        // console.log("CustomerFreightChargeService", this.freightCharges);

        if (this.salesOrderDetailLines.find((x) => x.SalesUMQty > 0)) {
          this.showLoading(true);
          this.setInitialPrices();
          this.showLoading(false);
        }
      }
    },
    getFreightCharge(salesUM) {
      let item = this.freightCharges.find(
        (x) => x.UnitOfMeasureCode.toUpperCase() == salesUM.toUpperCase(),
      );

      if (item) {
        // eslint-disable-next-line no-console
        // console.log("Freight", item.FreightCharge, salesUM);
        return item.FreightCharge;
      } else return 0;
    },
    formatNumber(number) {
      return Number(parseFloat(number).toFixed(2)).toLocaleString("en", {
        minimumFractionDigits: 2,
      });
    },
    customItemCreating(data) {
      if (!data.text) {
        data.customItem = null;
        return;
      }

      const newItem = {
        CompanyName: data.text,
        PhysicalAddressCountry: "",
        PhysicalAddressPostcode: "",
        PhysicalAddressState: "",
        PhysicalAddressStreetLine1: "",
        PhysicalAddressStreetLine2: "",
        PhysicalAddressSuburb: "",
      };

      data.customItem = newItem;
    },
    resetHeader() {
      this.salesOrderHeader.OrderNo = "";
      this.salesOrderHeader.AgentRef = "";
      this.salesOrderHeader.Confirmation =
        this.parentModel.Code + "-" + this.NextConfirmationNo;
      this.salesOrderHeader.UserComment1 = "";
      this.salesOrderHeader.UserComment2 = "";
      this.salesOrderHeader.UserComment3 = "";
      this.salesOrderHeader.UserComment4 = "";
      this.salesOrderHeader.UserComment5 = "";
      this.salesOrderHeader.UserComment6 = "";
      this.salesOrderHeader.UserComment7 = "";
      this.salesOrderHeader.UserComment8 = "";
      this.salesOrderHeader.UserComment9 = "";
      this.salesOrderHeader.UserComment10 = "";
      this.salesOrderHeader.UserComment11 = "";
      this.salesOrderHeader.UserComment12 = "";
      this.salesOrderHeader.UserComment13 = "";
      this.salesOrderHeader.UserComment14 = "";
      this.salesOrderHeader.UserComment15 = "";
      this.salesOrderHeader.UserComment16 = "";
      this.salesOrderHeader.UserComment17 = "";
      this.salesOrderHeader.UserComment18 = "";
      this.salesOrderHeader.UserComment19 = "";
      this.salesOrderHeader.UserComment20 = "";
      this.salesOrderHeader.ItemCount = 0;
      this.salesOrderHeader.ExTaxTotal = 0;
      this.salesOrderHeader.TaxTotal = 0;
      this.salesOrderHeader.Total = 0;
      this.salesOrderHeader.Status = "A";
      this.salesOrderHeader.CustomerCode = this.parentModel.CustomerCode;
      this.salesOrderHeader.CustomerDeliveryAddressLineNo = undefined;
      this.salesOrderHeader.DeliveryAddressCompanyName = "";
      this.salesOrderHeader.DeliveryAddressStreetLine1 = "";
      this.salesOrderHeader.DeliveryAddressStreetLine2 = "";
      this.salesOrderHeader.DeliveryAddressSuburb = "";
      this.salesOrderHeader.DeliveryAddressState = "";
      this.salesOrderHeader.DeliveryAddressPostcode = "";
      this.salesOrderHeader.DeliveryAddressCountry = "";
      this.salesOrderHeader.ShipDate = new Date();
      this.salesOrderHeader.RequiredByDate = new Date();
      this.salesOrderHeader.DateIn = new Date();
      this.salesOrderHeader.ExchangeRate = this.ExchangeRate;
    },
    showLoading(state) {
      this.isSaving = state;
      this.$emit("show-loading", state);
    },
    reset() {
      this.resetHeader();
      this.NextConfirmationNo = 1;
      this.salesOrderDetailLines = [];
    },
    recalculateRecordData(record) {
      record.SalesUMNetFXPrice = calculateSalesUMNetFXPriceFromSalesUMFXPrice(
        record.SalesUMFXPrice,
        record.DiscPcnt,
      );

      record.SalesUMPrice = calculateSalesUMPriceFromSalesUMFXPrice(
        record.SalesUMFXPrice,
        this.salesOrderHeader.ExchangeRate,
      );

      record.CalculatedDiscPcnt = calculateCalculatedDiscPcnt(
        record.SalesUMStandardPrice,
        record.SalesUMPrice,
      );

      record.SalesUMNetPrice = calculateSalesUMNetPriceFromSalesUMNetFXPrice(
        record.SalesUMNetFXPrice,
        this.salesOrderHeader.ExchangeRate,
      );

      // Stock
      // Stock
      record.StockUMFXPrice = calculateStockUMFXPrice(
        record.SalesUMFXPrice,
        record.SalesUMConversion,
      );

      record.StockUMNetFXPrice = calculateStockUMNetFXPrice(
        record.SalesUMNetFXPrice,
        record.SalesUMConversion,
      );

      record.StockUMPrice = calculateStockUMPrice(
        record.SalesUMPrice,
        record.SalesUMConversion,
      );

      record.StockUMNetPrice = calculateStockUMNetPrice(
        record.SalesUMNetPrice,
        record.SalesUMConversion,
      );

      // FX Totals
      record.DiscFXLineTotal = calculateDiscFXLineTotal(
        record.SalesUMFXPrice,
        record.SalesUMNetFXPrice,
        record.SalesUMQty,
      );
      record.NetFXLineTotal = calculateNetFXLineTotal(
        record.SalesUMNetFXPrice,
        record.SalesUMQty,
        record.SalesUMFXPrice
      );
      record.WetFXLineTotal = calculateWetFXLineTotal(
        record.NetFXLineTotal,
        record.WetPcnt,
      );
      record.TaxableFXLineTotal = calculateTaxableFXLineTotal(
        record.NetFXLineTotal,
        record.WetFXLineTotal,
      );
      record.TaxFXLineTotal = calculateTaxFXLineTotal(
        record.NetFXLineTotal,
        record.WetFXLineTotal,
        record.SalesTaxPcnt,
      );
      record.FXLineTotal = calculateFXLineTotal(
        record.TaxableFXLineTotal,
        record.TaxFXLineTotal,
      );

      // Totals
      record.DiscLineTotal = calculateDiscLineTotal(
        record.DiscFXLineTotal,
        this.salesOrderHeader.ExchangeRate,
      );
      record.NetLineTotal = calculateNetLineTotal(
        record.NetFXLineTotal,
        this.salesOrderHeader.ExchangeRate,
      );
      record.WetLineTotal = calculateWetLineTotal(
        record.WetFXLineTotal,
        this.salesOrderHeader.ExchangeRate,
      );
      record.TaxableLineTotal = calculateTaxableLineTotal(
        record.TaxableFXLineTotal,
        this.salesOrderHeader.ExchangeRate,
      );
      record.TaxLineTotal = calculateTaxLineTotal(
        record.TaxFXLineTotal,
        this.salesOrderHeader.ExchangeRate,
      );
      record.LineTotal = calculateLineTotal(
        record.FXLineTotal,
        this.salesOrderHeader.ExchangeRate,
      );

      this.calculateTotals();
    },
  },
};
</script>

<style lang="scss">
.generate-so-popup .dx-popup-content {
  padding: 0px !important;

  .generate-so-details {
    padding-top: 12px;
  }
}
</style>
<style lang="scss" scoped>
#popup-wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  .action-button {
    margin-left: 10px;
  }
  height: 100%;
}
#generate-so-scrollview {
  flex: 1;
  // height: calc(100% - 260px);
}
.footer-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
}
</style>
